import { css, styled } from '@mui/material';
import MUITypography from '@mui/material/Typography';

export const DescriptionContainer = styled('section')`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  padding: 1rem 2.5rem;
  ${({ theme }) => css`
    gap: ${theme.spacing(3)};
  `};

  ${({ theme }) => theme.breakpoints.up('md')} {
    padding: 2rem 2.5rem 2rem 19.5rem; // width of the StepMenuContainer(17rem) + 2.5rem
  }
`;

export const HeaderContainer = styled('div')`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  ${({ theme }) => css`
    gap: ${theme.spacing(2.5)};
  `};
`;

export const Header = styled('h1')`
  margin-bottom: 0;
  ${({ theme }) => css`
    font-size: ${theme.typography.h5.fontSize};
    font-weight: ${theme.typography.fontWeightMedium};
  `}
  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: ${({ theme }) => theme.typography.h1.fontSize};
  }
`;

export const SubHeader = styled('h2')`
  margin-bottom: 0;
  ${({ theme }) => css`
    font-size: ${theme.typography.h6.fontSize};
    font-weight: ${theme.typography.fontWeightBold};
  `}
  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: ${({ theme }) => theme.typography.h5.fontSize};
  }
`;

export const DescriptionText = styled(MUITypography)`
  text-wrap: balance;
  font-size: ${({ theme }) => theme.typography.body2.fontSize};
  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: ${({ theme }) => theme.typography.body1.fontSize};
  }
`;

export const StepContent = styled('section')`
  width: 100%;
  flex-grow: 1;
  display: flex;
  justify-content: start;
  flex-direction: column;
  align-items: end;
  background-color: ${({ theme }) => theme.palette.grey['100']};

  & > *:not(#create-product-footer) {
    width: 100%;
    padding: ${({ theme }) => theme.spacing(6)} ${({ theme }) => theme.spacing(3)};
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    & > *:not(#create-product-footer) {
      width: calc(100% - 17rem);
      padding: ${({ theme }) => theme.spacing(6)};
    }
  }
`;
